module.exports = __webpack_public_path__ + "static/media/management_graphic.2eddd1f2.png";